<div>
  <div>
    <input
      [(ngModel)]="name"
      (ngModelChange)="editedName=true"
      (keyup.enter)="submitName()"
    >

    <div class="label">
      Name
    </div>

    <button
      (click)="submitName()"
      [ngClass]="{'small': 1, 'loading': submittingName, 'inactive': !editedName}"
    >
      <span>Save</span>
      <motn-spinner></motn-spinner>
    </button>
  </div>

  <div>
    <input
      [(ngModel)]="subtitle"
      (ngModelChange)="editedSubtitle=true"
      (keyup.enter)="submitSubtitle()"
    >

    <div class="label">
      Subtitle
    </div>

    <button
      (click)="submitSubtitle()"
      [ngClass]="{'small': 1, 'loading': submittingSubtitle, 'inactive': !editedSubtitle}"
    >
      <span>Save</span>
      <motn-spinner></motn-spinner>
    </button>
  </div>

  <div>
    <input
      [(ngModel)]="postalCode"
      (ngModelChange)="editedPostalCode=true"
      (keyup.enter)="submitPostalCode()"
      maxlength="12"
    >

    <div class="label">
      Weather Postal Code
    </div>

    <button
      (click)="submitPostalCode()"
      [ngClass]="{'small': 1, 'loading': submittingPostalCode, 'inactive': !editedPostalCode}"
    >
      <span>Save</span>
      <motn-spinner></motn-spinner>
    </button>
  </div>
</div>

<div>
  <div class="image">
    @if (imgSource) {
      <img [src]="imgSource">
    }
  </div>

  <input
    #fileInput
    (change)="selectFile($event)"
    type="file"
    accept="image/jpeg,image/gif,image/png"
  >

  <div class="label">
    App Image
    <motn-info-circle
      [message]="'Supported image formats are GIF, JPG/JPEG, and PNG. Uploads must be no larger than 20MB.'"
    ></motn-info-circle>
  </div>

  <button
    (click)="submitUpload()"
    [ngClass]="{'small': 1, 'loading': submittingPicture, 'inactive': !editedPicture}"
  >
    <span>Upload File</span>
    <motn-spinner></motn-spinner>
  </button>
</div>

@if (canDelete) {
  <div class="buttons">
    <button
      (click)="deleteApp()"
      class="red"
    >
      <span>Delete App</span>
    </button>
  </div>
}
